import React, { useState } from 'react';
import { Form, Checkbox, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthProvider';
import './auth.css';
import AuthShell from '../../ui/AuthShell';
import Card from '../../ui/Card';
import AuthInput from '../../ui/AuthInput';
import Button from '../../ui/Button';
import AuthHeader from '../../ui/AuthHeader';

const AuthSignIn = () => {
  const { login } = useAuth();
  const location = useLocation();
  const tenantType = 'employee';
  const pill = 'For Nurses & Medical Professionals';
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await login(values.email, values.password, tenantType);
      message.success('Login successful!');
    } catch (error) {
      switch (error.code) {
        case 'auth/user-not-found':
          message.error('No user found with this email.');
          break;
        case 'auth/wrong-password':
          message.error('Incorrect password.');
          break;
        case 'auth/too-many-requests':
          message.error('Too many attempts. Please try again later.');
          break;
        default:
          message.error('Failed to login. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const showSignup = process.env.REACT_APP_SIGNUP_EMPLOYEE_ON === 'true';

  const signupLink = '/auth/signup';

  const subtitle = 'Welcome back. Access your assignments and manage your profile.';

  return (
    <AuthShell>
      <Card className="auth-form-wrapper" style={{ padding: 24 }}>
        <AuthHeader pillText={pill} title="Sign in to your account" subtitle={subtitle} />

        <Form name="login" onFinish={onFinish} layout="vertical" className="auth-form">
          <Form.Item
            name="email"
            label="Email address"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <AuthInput icon={<MailOutlined />} placeholder="you@email.com" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please enter your password!' }]}
          >
            <AuthInput icon={<LockOutlined />} type="password" placeholder="Enter your password" />
          </Form.Item>

          <Form.Item className="auth-form-options">
            <div className="auth-form-remember">
              <Checkbox>Remember me</Checkbox>
            </div>
            <Link className="auth-form-forgot" to="/forgot-password">
              Forgot password?
            </Link>
          </Form.Item>

          <Form.Item>
            <Button
              type="submit"
              disabled={loading}
              className="vs-btn vs-btn-primary auth-form-button"
              style={{ width: '100%' }}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </Button>
          </Form.Item>
          <div style={{ marginTop: 4, marginBottom: 8, textAlign: 'center', fontSize: 12, color: '#666' }}>
            By signing in to the portal, you agree to the{' '}
            <Link to="https://vitalstaf.com/terms">Terms</Link>
            <span> </span>
            and
            <span> </span>
            <Link to="https://vitalstaf.com/privacy">Privacy Policy</Link>.
          </div>
          {showSignup && (
            <div className="auth-form-footer" style={{ textAlign: 'center', marginTop: 4 }}>
              Don't have an account?{' '}
              <Link to={signupLink} className="auth-form-link">
                Create an account
              </Link>
            </div>
          )}
        </Form>
      </Card>
    </AuthShell>
  );
};

export default AuthSignIn;



